import { FC, useState } from 'react';
import { Class, Teacher } from '../../../Models/Class';
import Star from 'src/Icons/Star.svg';
import { groupByCategory } from 'src/Utils/GroupBy';
import {
  convertFrom24To12Format,
  getDurationFormat,
} from 'src/Utils/DateUtils';
import Enroll from './Enroll';
import TeacherModal from './TeacherModal';

interface ListViewProps {
  classes: Class[];
  loading: boolean;
}

type GroupView = {
  [key: string]: [];
};

const ListView: FC<ListViewProps> = ({ classes, loading }) => {
  const newArray: GroupView = groupByCategory(classes as [], 'start_date');
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [currentTeacher, setCurrentTeacher] = useState<Teacher>();
  const messages = [];
  const favorite = false;

  let wait_list_url = '';

  classes.map((item) => {
    item.messages.map(item => {
      if(item.type === 'class-full'){
        wait_list_url = item.url;
      }
      return true;
    });
    return true;
  });

  return (
    <>
      <div className={loading ? 'ContainerList loading' : 'ContainerList'}>
        <TeacherModal
          modalIsOpen={isModalOpen}
          closeModal={() => {
            setModalOpen(false);
          }}
          teacher={currentTeacher}
        />

        {classes.length === 0 &&
          loading &&
          Array.from({ length: 9 }, (_, i) => i).map((index) => (
            <div key={index} className='container_day'>
              <div className='class_item_list' style={{ height: '65px' }}></div>
            </div>
          ))}

        {Object.keys(newArray).map((key) => (
          <div className='container_day'>
            <h3>
              STARTING {getDurationFormat(key)}{' '}
              <span>
                {newArray[key]
                  .map((item: Class) => item.messages)
                  .flat()
                  .find((item) => item.type === 'can-still-enroll')
                  ? newArray[key]
                    .map((item: Class) => item.messages)
                    .flat()
                    .filter((item) => item.type === 'can-still-enroll')
                    .length > 1
                    ? 'You can still enroll in these classes!'
                    : 'You can still enroll in this class!'
                  : ''}
              </span>
            </h3>
            {newArray[key].map((item: Class) => {
              return (
                <>
                  <div className='titles'>
                    {item.messages
                      .filter((item) => item.type !== 'can-still-enroll')
                      .map((item) => (
                        <div className={`title ${item.type}`}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: item.text,
                            }}
                          />
                        </div>
                      ))}
                  </div>
                  <div className='class_item_list' key={item.id}>
                    <div className='info_list'>
                      <div className='class_name'>
                        <a
                          href={`/courses/${item.course.slug}/${item.slug}/`}
                          className='class_item_list_name'
                        >
                          {item.name}
                        </a>
                        <span className='spots_left'>
                          {item.available_spots_text}
                        </span>
                      </div>
                      {item.modality.toLowerCase() === 'zoom' ||
                        item.modality.toLowerCase() === 'nyc' ? (
                        <span className='class_item_list_modality'>
                          {item.modality_url !== '' ?
                            <a href={item.modality_url} target={`_blank`}>{item.modality}</a>
                            :
                            item.modality
                          }
                          {item.start_time && item.end_time && (
                            <span className='class_item_list_modality_time'>
                              {', '}
                              {item.days}{' '}
                              {convertFrom24To12Format(item.start_time)} -{' '}
                              {convertFrom24To12Format(item.end_time)} ET
                            </span>
                          )}
                        </span>
                      ) : (
                        <span className='class_item_list_modality'>
                          {item.modality_url !== '' ?
                            <a href={item.modality_url} target={`_blank`}>{item.modality}</a>
                            :
                            item.modality
                          }
                          {item.modality.toLowerCase() === 'online'
                            ? `, anytime`
                            : ``
                          }
                        </span>
                      )}

                      <span className='class_item_list_length'>
                        {item.length_format}
                      </span>
                      <button
                        className='teacher_btn'
                        onClick={() => {
                          setCurrentTeacher(item.teacher);
                          setModalOpen(true);
                        }}
                      >
                        <span className='class_item_list_teacher'>
                          {item?.teacher?.name}
                        </span>
                      </button>

                      <Enroll
                        product_id={item.product_id}
                        can_enroll={item.can_enroll}
                        call={false}
                        url={wait_list_url}
                      />
                      <span className={(item.favorite ? 'wish-list-star right active' : 'wish-list-star right') + (!item.can_enroll ? ' disabled' : '')} data-type="class" data-id={item.id} data-course={item.course.id}><span className="label"></span></span>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        ))}
      </div>
    </>
  );
};

export default ListView;
